<template>
  <div>
    <div class="section">
      <div class="loader" />
    </div>
  </div>
</template>



<script>
  import { mapGetters } from 'vuex';



  export default {
    name: 'OrderAtTableSelectOrderPage',

    metaInfo() {
      return {
        title: 'Select Order'
      };
    },

    data() {
      return {
        orderIsLoading: false
      };
    },

    computed: {
      ...mapGetters('orders', ['order']),
      ...mapGetters('session', ['session'])
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (this.order.orderId) {
          this.selectOrder(this.order);
        }

        else {
          this.redirectToMenu();
        }
      },

      redirectToMenu() {
        this.$router.replace({
          name: 'orderAtTableMenu',
          params: {
            merchantId: this.$route.params.merchantId
          },
          query: {
            ml: this.session.route.merchantLocationId,
            tb: this.session.route.tableNumber
          }
        });
      },

      selectOrder(order) {
        if (order.orderItems.length === 0 || order.orderItemsStaged.length > 0) {
          this.redirectToMenu();
        }

        else {
          this.$store.dispatch('orders/cacheOrderSelection', order);

          this.$router.replace({
            name: 'payAtTableCheckout',
            params: {
              merchantId: this.$route.params.merchantId
            },
            query: {
              ml: this.session.route.merchantLocationId,
              oi: order.orderId,
              tb: this.session.route.tableNumber
            }
          });
        }
      }
    }
  };
</script>
